import { render, staticRenderFns } from "./ContactTemplate.vue?vue&type=template&id=42dc7baf&scoped=true&"
import script from "./ContactTemplate.vue?vue&type=script&lang=js&"
export * from "./ContactTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ContactTemplate.vue?vue&type=style&index=0&id=42dc7baf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc7baf",
  null
  
)

export default component.exports